export default "__VITE_ASSET__DzJqvb7N__"